import { CourseContent } from '@components/enrollments/courses/CourseContent'
import { CourseGhostLoading } from '@components/enrollments/courses/CourseGhostLoading'
import { FeaturedCourseRedirect } from '@components/FeaturedProduct/FeaturedCourseRedirect'
import { CourseContentsProvider } from '@contexts/CourseContentsContext'
import { CourseProvider } from '@contexts/CourseContext'
import { EnrollmentProvider } from '@contexts/EnrollmentContext'
import { ExtraContentsProvider } from '@contexts/ExtraContentsContext'
import { LessonExtraContentsProvider } from '@contexts/LessonExtraContentsContext'
import { ModulesProvider } from '@contexts/ModulesContext'
import { CourseContextsResetProvider } from '@contexts/CourseContextsReset'
import { usePreviousRoute } from '@hooks/usePreviousRoute'
import { useUpNavigation } from '@hooks/useUpNavigation'
import { AppLayout } from '@layouts/AppLayout'
import { useCurrentLesson } from '@hooks/useCurrentLesson'
import { ReactNode, useEffect } from 'react'

/** Página do curso, compartilhada entre a rota do aluno e o preview do produtor. */
export function CourseScreen() {
  const { setCurrentLesson } = useCurrentLesson()
  const { backLabel } = usePreviousRoute()
  const goUp = useUpNavigation()

  useEffect(() => {
    setCurrentLesson(null)
  }, [setCurrentLesson])

  const layout = (children: ReactNode) => (
    <AppLayout
      backRoute={{
        label: backLabel,
        back: goUp,
      }}
      hasPaddingBottom={false}
      backgroundColor="$bg-chrome"
    >
      {children}
    </AppLayout>
  )

  return (
    <FeaturedCourseRedirect fallback={layout(<CourseGhostLoading />)}>
      <CourseProvider>
        <CourseContentsProvider>
          <ModulesProvider>
            <LessonExtraContentsProvider>
              <ExtraContentsProvider>
                <EnrollmentProvider>
                  <CourseContextsResetProvider>
                    {layout(<CourseContent />)}
                  </CourseContextsResetProvider>
                </EnrollmentProvider>
              </ExtraContentsProvider>
            </LessonExtraContentsProvider>
          </ModulesProvider>
        </CourseContentsProvider>
      </CourseProvider>
    </FeaturedCourseRedirect>
  )
}
